import { jwtDecode, JwtPayload } from "jwt-decode";

import { User } from "@/types/user";

export interface DecodedToken extends JwtPayload {
  mfa_verified?: boolean;
}

/** Where to send the user after auth when MFA or email verification is still pending. */
export const resolvePendingAuthStep = (accessToken: string, user: User): string | null => {
  if (!user.verified && user.workos_user_id) {
    return `/verify-email?email=${encodeURIComponent(user.email)}`;
  }

  if (user.mfa_type) {
    const decoded = jwtDecode<DecodedToken>(accessToken);
    if (!decoded.mfa_verified) {
      return "/verify-mfa";
    }
  }

  return null;
};

/** Login page redirect when a session already exists. Returns null to stay on login. */
export const resolveAuthenticatedLoginRedirect = (
  accessToken: string,
  user: User,
): string | null => {
  const pending = resolvePendingAuthStep(accessToken, user);
  if (pending) {
    return pending;
  }

  if (user.verified) {
    return "/";
  }

  return null;
};
